import React from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../assets/styles/Header.css";
import footer_logo from "../assets/images/PL_logo_ohne_background_v003.png";
import { faCat } from "@fortawesome/free-solid-svg-icons";
import { faHeart } from "@fortawesome/free-solid-svg-icons";


function Footer() {

  const { i18n, t } = useTranslation();
  
  return (
    <div class="footer py-5 text-center">
        <div class="container">
            <div class="row mb-4">
              <a class="navbar-brand d-block mx-auto" href="/"><img
                src={footer_logo} id="imgLogoTop" alt="PristaneLaverie logo" class="d-block mx-auto"/>
              </a>
            </div>
            <hr></hr>
            <div class="footerAddress d-flex align-items-center">
              <p class="mx-auto">43 Rue du Chablais - 74100 Annemasse (Grand Génève)</p>
            </div>
            <div class="footerAddress d-flex align-items-center">
               <p class="mx-auto"><a href="tel:0033658919639">{t("footer_text_1")} (0033) 06 58 91 96 39</a></p>
            </div>
            <div class="d-flex align-items-center"> 
              <p class="mx-auto"> 
                <a href="">{t("footer_text_2")}</a> - <a href="">{t("footer_text_3")}</a> - <a href="">{t("footer_text_4")}</a> <span class="">-</span>{t("footer_text_5")}<FontAwesomeIcon icon={faHeart}/> by <a rel="noreferrer noopener" href="" target="_blank">PatrickHUB</a> </p> 
            </div>
            <div class="d-flex align-items-center">
               <p class="mx-auto">{t("footer_text_6")}<a rel="noreferrer noopener" href="https://policies.google.com/privacy?hl=fr" target="_blank">{t("footer_text_7")}</a>{t("footer_text_8")}<a rel="noreferrer noopener" href="https://policies.google.com/terms?hl=fr" target="_blank">{t("footer_text_9")}</a>{t("footer_text_10")}</p>
            </div>
        </div>
    </div>
    
  );
}

export default Footer;
